<template>
  <div class="business-dashboard">
    <!-- 顶部时间筛选栏 -->
    <div class="time-filter">
      <el-radio-group v-model="timeRange" @change="handleTimeChange">
        <el-radio-button label="今日"></el-radio-button>
        <el-radio-button label="昨日"></el-radio-button>
        <el-radio-button label="本周"></el-radio-button>
        <el-radio-button label="本月"></el-radio-button>
        <el-radio-button label="自定义"></el-radio-button>
      </el-radio-group>
      <div class="filter-actions">
        <el-button type="text" icon="el-icon-video-play">视频</el-button>
        <el-button type="text" icon="el-icon-question">帮助</el-button>
        <el-button type="text" icon="el-icon-document">查看经营流水</el-button>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 左侧主要数据区域 -->
      <div class="left-panel">
        <!-- 销售情况 -->
        <el-card class="sales-card">
          <div slot="header" class="card-header">
            <span>销售情况</span>
          </div>
          <div class="sales-content">
            <div class="sales-total">
              <div class="total-amount">11,803,061.00</div>
              <div class="sales-detail">
                <div class="detail-item">
                  <span class="label">首客</span>
                  <span class="value">首客(37家)11,195,611.00</span>
                </div>
                <div class="detail-item">
                  <span class="label">回购</span>
                  <span class="value">回购(33家)607,450.00</span>
                </div>
                <div class="detail-item">
                  <span class="label">客单价</span>
                  <span class="value">302584.08</span>
                  <span class="value">18407.58</span>
                </div>
                <div class="detail-item">
                  <span class="label">退货金额</span>
                  <span class="value red">0.00</span>
                  <span class="label">(0笔)</span>
                </div>
                <div class="detail-item">
                  <span class="label">销售</span>
                  <span class="value">(245笔)</span>
                </div>
              </div>
            </div>
            <div class="profit-info">
              <div class="profit-item">
                <span class="label">毛利</span>
                <span class="value">11,211,661.10</span>
              </div>
              <div class="profit-item">
                <span class="label">毛利率</span>
                <span class="value">94.99%</span>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 收款情况 -->
        <el-card class="payment-card">
          <div slot="header" class="card-header">
            <span>收款情况</span>
          </div>
          <div class="payment-content">
            <div class="payment-total">
              <div class="total-amount">570,891.00</div>
              <div class="payment-detail">
                <div class="detail-item">
                  <span class="label">收款</span>
                  <span class="value">(204笔)</span>
                </div>
                <div class="detail-item">
                  <span class="label">收预收款</span>
                  <span class="value">(1笔)4,390.00</span>
                </div>
                <div class="detail-item">
                  <span class="label">退款收款</span>
                  <span class="value">(0笔)0.00</span>
                </div>
                <div class="detail-item">
                  <span class="label">当日开单当日收款</span>
                  <span class="value">(203笔)566,501.00</span>
                </div>
                <div class="detail-item">
                  <span class="label">欠款收回</span>
                  <span class="value">(0笔)0.00</span>
                </div>
              </div>
            </div>
            <div class="payment-methods">
              <div class="method-item">
                <span class="label">收款</span>
                <span class="value">(203笔)</span>
              </div>
              <div class="method-chart">
                <div class="chart-bar">
                  <div class="bar-segment" style="width: 0%; background-color: #f56c6c;"></div>
                  <div class="bar-segment" style="width: 0.77%; background-color: #e6a23c;"></div>
                  <div class="bar-segment" style="width: 0%; background-color: #67c23a;"></div>
                  <div class="bar-segment" style="width: 99.23%; background-color: #409eff;"></div>
                  <div class="bar-segment" style="width: 0%; background-color: #909399;"></div>
                </div>
                <div class="chart-labels">
                  <span>0.00</span>
                  <span>0.77%</span>
                  <span>0%</span>
                  <span>99.23%</span>
                  <span>0%</span>
                </div>
              </div>
            </div>
            <div class="profit-info">
              <div class="profit-item">
                <span class="label">毛利</span>
                <span class="value">11,211,661.10</span>
              </div>
              <div class="profit-item">
                <span class="label">毛利率</span>
                <span class="value">94.99%</span>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 旺铺和微商城 -->
        <div class="shop-cards">
          <el-card class="shop-card">
            <div slot="header" class="card-header">
              <span>旺铺</span>
            </div>
            <div class="shop-content">
              <div class="shop-item">
                <span class="label">在线订单</span>
                <span class="value">0.00,0笔</span>
              </div>
              <div class="shop-item">
                <span class="label">客单价</span>
                <span class="value"></span>
              </div>
              <div class="shop-item">
                <span class="label">旺铺浏览量</span>
                <span class="value">92次</span>
              </div>
              <div class="shop-item">
                <span class="label">新增潜客</span>
                <span class="value">0人</span>
              </div>
            </div>
          </el-card>

          <el-card class="shop-card">
            <div slot="header" class="card-header">
              <span>微商城</span>
            </div>
            <div class="shop-content">
              <div class="shop-item">
                <span class="label">在线订单</span>
                <span class="value">0.00,0笔</span>
              </div>
              <div class="shop-item">
                <span class="label">退货金额</span>
                <span class="value">0.00,0笔</span>
              </div>
              <div class="shop-item">
                <span class="label">净销金额</span>
                <span class="value">0.00</span>
              </div>
            </div>
          </el-card>
        </div>
      </div>

      <!-- 右侧数据面板 -->
      <div class="right-panel">
        <el-card class="data-card">
          <div class="data-item">
            <span class="label">进货情况</span>
            <span class="value">进货金额(笔数):1826038980.6(122笔)</span>
          </div>
          <div class="data-item">
            <span class="label">付款情况</span>
            <span class="value">付款金额(笔数):1554288930(114笔)</span>
          </div>
          <div class="data-item">
            <span class="label">日常收支</span>
            <span class="value">其他收入(笔数):0(0笔)</span>
            <span class="value">费用支出(笔数):11635(24笔)</span>
          </div>
          <div class="data-item">
            <span class="label">生产情况</span>
            <span class="value">产品入库(笔数):0(0笔)</span>
            <span class="value">材料出库(笔数):0(0笔)</span>
          </div>
          <div class="data-item">
            <span class="label">盘点调拨</span>
            <span class="value">分量盘点:0笔</span>
            <span class="value">调拨:0笔</span>
            <span class="value">总量盘点:1笔</span>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BusinessDashboard',
  data() {
    return {
      timeRange: '今日'
    }
  },
  methods: {
    handleTimeChange(value) {
      console.log('时间范围变更:', value);
      // 这里可以添加获取对应时间范围数据的逻辑
    }
  }
}
</script>

<style lang="less">
.business-dashboard {
  background-color: #f5f7fa;
  min-height: calc(90vh - 50px);
  padding: 20px;
  max-height: 80vh;
  overflow-y: auto;
  
  .time-filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    background: #fff;
    padding: 15px 20px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    .filter-actions {
      .el-button {
        margin-left: 15px;
        padding: 8px 12px;
        
        &:hover {
          background-color: #f5f7fa;
          border-radius: 4px;
        }
      }
    }
  }
  
  .main-content {
    display: flex;
    gap: 20px;
    
    .left-panel {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    
    .right-panel {
      width: 300px;
    }
  }
  
  .el-card {
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    .card-header {
      font-weight: bold;
      font-size: 16px;
      color: #303133;
      border-bottom: 1px solid #ebeef5;
      padding-bottom: 10px;
    }
  }
  
  .sales-card, .payment-card {
    .sales-content, .payment-content {
      display: flex;
      justify-content: space-between;
      
      .sales-total, .payment-total {
        flex: 1;
        
        .total-amount {
          font-size: 28px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 15px;
        }
        
        .sales-detail, .payment-detail {
          .detail-item {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            
            .label {
              width: 120px;
              color: #606266;
              font-size: 14px;
            }
            
            .value {
              color: #303133;
              font-size: 14px;
              
              &.red {
                color: #f56c6c;
                font-weight: bold;
              }
            }
          }
        }
      }
      
      .profit-info {
        width: 200px;
        border-left: 1px solid #ebeef5;
        padding-left: 20px;
        
        .profit-item {
          margin-bottom: 15px;
          
          .label {
            display: block;
            color: #606266;
            font-size: 14px;
            margin-bottom: 5px;
          }
          
          .value {
            font-size: 18px;
            font-weight: bold;
            color: #303133;
          }
        }
      }
    }
  }
  
  .payment-card {
    .payment-content {
      .payment-methods {
        width: 300px;
        border-left: 1px solid #ebeef5;
        padding-left: 20px;
        
        .method-item {
          margin-bottom: 10px;
          
          .label {
            color: #606266;
            font-size: 14px;
          }
          
          .value {
            color: #303133;
            font-size: 14px;
          }
        }
        
        .method-chart {
          .chart-bar {
            display: flex;
            height: 20px;
            border-radius: 10px;
            overflow: hidden;
            margin-bottom: 5px;
            
            .bar-segment {
              height: 100%;
              transition: width 0.3s;
            }
          }
          
          .chart-labels {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            color: #909399;
          }
        }
      }
    }
  }
  
  .shop-cards {
    display: flex;
    gap: 20px;
    
    .shop-card {
      flex: 1;
      
      .shop-content {
        .shop-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid #f0f0f0;
          
          &:last-child {
            border-bottom: none;
          }
          
          .label {
            color: #606266;
            font-size: 14px;
          }
          
          .value {
            color: #303133;
            font-size: 14px;
          }
        }
      }
    }
  }
  
  .right-panel {
    .data-card {
      .data-item {
        padding: 12px 0;
        border-bottom: 1px solid #f0f0f0;
        
        &:last-child {
          border-bottom: none;
        }
        
        .label {
          display: block;
          color: #606266;
          font-size: 14px;
          margin-bottom: 5px;
          font-weight: bold;
        }
        
        .value {
          display: block;
          color: #303133;
          font-size: 14px;
          margin-bottom: 3px;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .business-dashboard {
    .main-content {
      flex-direction: column;
      
      .right-panel {
        width: 100%;
      }
    }
  }
}

@media (max-width: 768px) {
  .business-dashboard {
    padding: 10px;
    
    .time-filter {
      flex-direction: column;
      align-items: flex-start;
      
      .filter-actions {
        margin-top: 10px;
        
        .el-button {
          margin-left: 0;
          margin-right: 10px;
        }
      }
    }
    
    .sales-card, .payment-card {
      .sales-content, .payment-content {
        flex-direction: column;
        
        .profit-info, .payment-methods {
          width: 100%;
          border-left: none;
          border-top: 1px solid #ebeef5;
          padding-left: 0;
          padding-top: 15px;
          margin-top: 15px;
        }
      }
    }
    
    .shop-cards {
      flex-direction: column;
    }
  }
}
</style>